module.exports = __webpack_public_path__ + "static/media/pic_3.46fbe0c4.png";